import React, { useState } from "react";


const Getusers = (props) => {
  const [userInfo] = useState({
    name:  localStorage.getItem("userName"),
    email: localStorage.getItem("myemail"),
  });

  
  
  
  const getNameAbbreviation = (fullName) => {
    if(fullName !== undefined){
      const trimmedName = fullName && fullName.trim();
      const nameParts =trimmedName && trimmedName.split(' ').filter(part => part.length > 0);
  
      if (nameParts.length >= 2) {
        const firstName = nameParts[0];
      const firstLetter = firstName.charAt(0);
      return `${firstLetter}`.toUpperCase();
      }
  
      return '';
  
    }
  };

  const getFirstName = (fullName) => {
    if(fullName !== undefined){
      const trimmedName = fullName.trim();
      const nameParts =trimmedName&& trimmedName.split(' ').filter(part => part.length > 0);
  
      if (nameParts.length >= 2) {
        const firstName = nameParts[0];
      const firstLetter = firstName;
      return `${firstLetter}`
      }
  
      return '';
  
    }
  };




  return (
    <> 
      {props?.name && <span style={{ display: "grid", gridGap: "5px",justifyContent: props.align || "start" }} className={`colorCss ${props.className}`}>{userInfo?.name}</span>}
      {props?.email && <span style={{ display: "grid", gridGap: "5px",justifyContent: props.align || "start" }} className={`colorCss ${props.className}`}>{userInfo?.email}</span>}
      {props?.trim && <span style={{ display: "grid", gridGap: "5px",justifyContent: props.align || "start" }} className={`colorCss ${props.className}`}>{getNameAbbreviation(userInfo?.name)}</span>}
      {props?.firstName && <span style={{ display: "grid", gridGap: "5px",justifyContent: props.align || "start" }} className={`userinfo colorCss ${props.className}`}>{getFirstName(userInfo?.name)}</span>}

    </>
  );
}

export default Getusers
